import { Button } from '@material-ui/core'
import IconHelp from '@material-ui/icons/Help'
import { FunctionComponent, useContext, useState } from 'react'
import { logIn, logOut } from '../../utils/authentication'
import { AppContext } from '../AppContext'
import { Help } from '../Help'
import { IconLogin } from '../Shared/Icons/IconLogin'
import { IconLogout } from '../Shared/Icons/IconLogout'
import { Logo } from './Logo'
import { UsageMeter } from './UsageMeter'

interface HeaderProps {
	isAuthenticated: boolean
}

export const Header: FunctionComponent<HeaderProps> = ({ isAuthenticated }) => {
	const [isHelpOpen, setIsHelpOpen] = useState(false)
	const { clientConfig, usage, userInfo } = useContext(AppContext)
	// only meaningful for a signed-in user who is allowed to spend tokens
	const showUsageMeter = isAuthenticated && !!userInfo?.hasAccess && !!usage
	return (
		<header className="flex justify-between items-center pa3 bg-color-white bb b--lightest-grey">
			<Logo />
			<div className="flex items-center">
				{showUsageMeter && (
					<UsageMeter usage={usage} clientConfig={clientConfig} onLearnMore={() => setIsHelpOpen(true)} />
				)}
				<Button className="btn-primary-light mb0 mr1" onClick={() => setIsHelpOpen(true)}>
					<IconHelp /> Help
				</Button>
				{!isAuthenticated ? (
					<Button onClick={logIn} className="btn-primary mb0">
						<IconLogin /> Log In
					</Button>
				) : (
					<Button onClick={logOut} className="btn-primary-light mb0 w-40">
						<IconLogout /> Log Out
					</Button>
				)}
			</div>
			{isHelpOpen && <Help onHide={() => setIsHelpOpen(false)} />}
		</header>
	)
}
